// Operaciones — panel de salud operacional (admin/coordinador).
//
// Tres pestañas: gestión de casos, ventas en vivo y cuadre de caja.
//
// "Revisión de casos" y "Reembolsos" se fusionaron en "Casos": mostraban el MISMO
// caso en dos lugares distintos —se revisaba en una y se marcaba el reembolso en la
// otra—, así que el operador tenía que saltar de pestaña y armar de memoria qué le
// faltaba. Ahora cada caso se recorre entero en un flujo de cuatro pasos: qué pasó,
// qué variables tiene, a dónde lo llevo, y ejecutar.

import React from 'react';
import useAuthContext from '../../../../hooks/useAuthContext';
import { soloVeTorniquete } from '../../../../config/menuAdminConfig';
import { Typography, Tabs } from 'antd';
import {
  MonitorOutlined, CalculatorOutlined, AlertOutlined, SafetyCertificateOutlined
} from '@ant-design/icons';
import VentasEnVivo from './VentasEnVivo';
import GestionCasos from './GestionCasos';
import CuadreCaja from './CuadreCaja';
import Torniquete from './Torniquete';

const { Title, Paragraph } = Typography;

export default function Operaciones() {
  const { user } = useAuthContext();

  const soloTorniquete = soloVeTorniquete(user);

  const pestanas = [
    { key: 'casos', label: <span><AlertOutlined /> Casos</span>, children: <GestionCasos /> },
    { key: 'ventas', label: <span><MonitorOutlined /> Ventas en vivo</span>, children: <VentasEnVivo /> },
    { key: 'cuadre', label: <span><CalculatorOutlined /> Cuadre de caja</span>, children: <CuadreCaja /> },
    { key: 'torniquete', label: <span><SafetyCertificateOutlined /> Torniquete</span>, children: <Torniquete /> },
  ];

  return (
    <div style={{ padding: 8 }}>
      <Title level={3} style={{ marginBottom: 4 }}>
        <MonitorOutlined /> Operaciones
      </Title>
      <Paragraph type="secondary">
        Casos por resolver, anomalías en vivo, cuadre diario y control de acceso.
      </Paragraph>

      {/* "Salud de cupos" sigue OCULTA, no borrada: el endpoint, el análisis del drift
          y la reconciliación funcionan, y `scripts/verOperaciones.js --cupos` los usa. */}
      <Tabs
        defaultActiveKey={soloTorniquete ? 'torniquete' : 'casos'}
        destroyInactiveTabPane
        items={soloTorniquete ? pestanas.filter(p => p.key === 'torniquete') : pestanas}
      />
    </div>
  );
}
